import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { switchMap, map } from 'rxjs/operators';
import { IndentRequestHeaderData, IndentRequestHeader } from '../../../interfaces/pharmacy/IndentRequestHeader';
import { IndentRequestApi } from '../api/IndentRequest.api';

@Injectable() 
export class IndentRequestService extends IndentRequestHeaderData{
 
  constructor(private api: IndentRequestApi) {
    super();
  } 
  
  getall(url: string): Observable<any[]> { 
    return this.api.getall(url);
  } 

  getById(url:string): Observable<any>{
      return this.api.getby_id(url);
  }

  create(url: string, data:any): Observable<any[]> {
    return this.api.add(url,data);
  }

  update(url: string, data:any): Observable<any> { 
    return this.api.update(url,data);
  }  

  list(url: string): Observable<any> {
    return this.api.list(url);
  }

  searchList(url: string,data:any): Observable<any> {  
    return this.api.searchList(url,data);
  }
}
